export default "__VITE_ASSET__Cuh00URi__"